import ReactAce from "react-ace/lib/ace";
import { MainContainer } from "./styles";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai";

const v3Way = `import MoreVertIcon from 'react-ionicons/lib/IosMenu'
import MdCreate from 'react-ionicons/lib/MdCreate'
import IosInformationCircleOutline from 'react-ionicons/lib/IosInformationCircleOutline'
`

const v4Way = `import { MoreVertIcon } from 'react-ionicons'
import { Create } from 'react-ionicons'
import { InformationCircleOutline } from 'react-ionicons'`

const MigrationFromV3 = () =>
  <MainContainer>
    <h1 style={{textAlign: 'center', color: '#171c24'}}>Migration from v3 to v4</h1>
    <p>react-ionicons v4 introduces some break changes but not many. To migrate from v3 to v4 follow the next steps.</p>
    <h2 style={{textAlign: 'center', color: '#171c24'}}>Breaking changes</h2>
      <ul>
        <li>Import way</li>
        <li>Delete Md* icons</li>
        <li>Delete Ios* icons</li>
      </ul>
    <h2 style={{textAlign: 'center', color: '#171c24'}}>
      Manually migration
    </h2>
    <p>
      If your application is small you can do the migrations manually. The differences between v3 and v4 is the name of the components
      and the way to import the icons.
    </p>
    <p>For example in v3 we used this way to import the ionicons:</p>
    <ReactAce readOnly value={v3Way} height="60px" width="100%"  mode="javascript" theme="monokai" />
    <p>react-ionicons v4 changes the way to import icons:</p>
    <ReactAce readOnly value={v4Way} height="60px" width="100%"  mode="javascript" theme="monokai" />
    <h2 style={{textAlign: 'center', color: '#171c24'}}>
      Automatic migration
    </h2>
    <p>
      Exists a script to automate this migrations. The scripts go through your application and replace all icons and fix the imports in react-ionicons
      v4 way.
    </p>
    <p>The script is inside <code>migrations/</code> folder in the <a href="https://github.com/zamarrowski/react-ionicons" rel="noreferrer" target="_blank">repository</a></p>
    <p><b>Before running the script modify the path to your app in line 50 of the script</b></p>
    <p>If you have some troubles running the scripts open a issue in Github with the error description</p>
  </MainContainer>

export default MigrationFromV3